import { company } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Fire-and-forget log of a WhatsApp chat start (internal use only). */
export const trackWhatsApp = (text, source = "floating-button", extra = {}) => {
  try {
    const body = JSON.stringify({
      message: text,
      source,
      page: window.location.pathname + window.location.search,
      name: extra.name || "",
      phone: extra.phone || "",
      email: extra.email || "",
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/whatsapp-clicks`, new Blob([body], { type: "application/json" }));
    } else {
      fetch(`${API}/whatsapp-clicks`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
  } catch {
    /* ignore */
  }
};

const line = (label, value) => (value ? `${label}: ${value}\n` : "");

/** Build a plain-text summary of an enquiry / quote for WhatsApp & email */
export const buildEnquiryText = (v, type = "general") => {
  const heading = type === "quote" ? "Quote Request - Anjaneya Inks and Coating" : "New Enquiry - Anjaneya Inks and Coating";
  let text = `${heading}\n\n`;
  text += line("Name", v.name);
  text += line("Company", v.company);
  text += line("Phone", v.phone);
  text += line("Email", v.email);
  if (type === "quote") {
    text += "\n";
    text += line("Product", v.product);
    text += line("Quantity", v.quantity ? `${v.quantity} ${v.unit || ""}`.trim() : "");
    text += line("Shade / Pantone", v.shade);
    text += line("Print process", v.print_process);
    text += line("Substrate", v.substrate);
  }
  if (v.message) text += `\nMessage:\n${v.message}\n`;
  text += "\n(Sent from the website enquiry form)";
  return text;
};

export const whatsappUrl = (text) =>
  `https://wa.me/${company.enquiryWhatsapp}?text=${encodeURIComponent(text)}`;

export const mailtoUrl = (text, type = "general") => {
  const subject = type === "quote" ? "Quote Request from website" : "New Enquiry from website";
  return `mailto:${company.enquiryEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`;
};

/** Opens WhatsApp click-to-chat in a new tab (falls back silently if blocked) */
export const openWhatsApp = (text, source = "enquiry-form", extra = {}) => {
  trackWhatsApp(text, source, extra);
  try {
    const w = window.open(whatsappUrl(text), "_blank", "noopener,noreferrer");
    return !!w;
  } catch {
    return false;
  }
};
